import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/helpers/auth';

Vue.use(Router);

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

export default new Router({
	mode: 'history',
	// mode: 'hash',
	duplicateNavigationPolicy: 'ignore',
	base: process.env.BASE_URL,
	routes: [{
		path: '/login',
		name: 'login',
		beforeEnter: isUnauth,
		component: () => import ('@/views/vo/auth/Login.vue'),
	},
	{
		path: '/sso/:token',
		name: 'sso',
		// beforeEnter: isUnauth,
		component: () => import ('@/views/vo/auth/LoginSSO.vue'),
	},
	{
		path: '/',
		component: () => import ('@/views/vo/layout/Main.vue'),
		children: [{
			path: '/',
			name: 'dashboard',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/dashboard/Dashboard.vue')
		},
		{
			path: '/profil/',
			name: 'profil',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/profil/profil/Profil.vue')
		},
		{
			path: '/ubah-password/',
			name: 'ubah-password',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/profil/ubahPassword/UbahPassword.vue')
		},
		{
			path: '/genealogy/:network_code?',
			name: 'genealogy',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/genealogy/Genealogy.vue')
		},
		{
			path: '/prospek-mitra/',
			name: 'prospek-mitra',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/prospekMitra/ProspekMitra.vue')
		},
		{
			path: '/sponsor-pribadi/',
			name: 'Sponsor Pribadi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/sponsorPribadi/SponsorPribadi.vue')
		},
		{
			path: '/downline/',
			name: 'downline',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/downline/Downline.vue')
		},
		{
			path: '/pertumbuhan-jaringan/',
			name: 'pertumbuhan-jaringan',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/jaringan/pertumbuhanJaringan/PertumbuhanJaringan.vue')
		},
		// {
		// 	path: '/registrasi-mitra/',
		// 	name: 'registrasi-mitra',
		// 	beforeEnter: isAuth,
		// 	component: () => import ('@/views/vo/jaringan/registrasi/Registration.vue')
		// },
		{
			path: '/summary-komisi/',
			name: 'summary-komisi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/summaryKomisi/SummaryKomisi.vue')
		},
		{
			path: '/histori-komisi/',
			name: 'histori-komisi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/historiKomisi/HistoriKomisi.vue')
		},
		{
			path: '/histori-komisi-team/',
			name: 'histori-komisi-team',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/historiKomisiTeam/HistoriKomisiTeam.vue')
		},
		{
			path: '/histori-klaim/',
			name: 'histori-klaim',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/historiKlaim/HistoriKlaim.vue')
		},
		{
			path: '/history-transfer/:slug',
			name: 'bonus-statement',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/historiKlaim/components/BonusStatement.vue')
		},
		{
			path: '/klaim-komisi/',
			name: 'klaim-komisi',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/komisi/klaimKomisi/KlaimKomisi.vue')
		},
		{
			path: '/belanja-produk/',
			name: 'belanja-produk',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/belanjaProduk/BelanjaProduk.vue')
		},
		{
			path: '/lap-pembelian-produk/',
			name: 'lap-pembelian-produk',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/lapPembelianProduk/LapPembelianProduk.vue')
		},
		{
			path: '/lap-pembelian-produk/:type/:slug',
			name: 'detail-pembelian-produk',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/lapPembelianProduk/DetailPembelianProduk.vue')
		},
		{
			path: '/lap-pembelian-produk/:slug',
			name: 'print-pembelian-produk',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/lapPembelianProduk/PrintPembelianProduk.vue')
		},
		{
			path: '/list-upload-bukti/',
			name: 'list-upload-bukti',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/listUploadBukti/ListUploadBukti.vue')
		},
		{
			path: '/list-upload-bukti/:type/:slug',
			name: 'detail-upload-bukti',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/listUploadBukti/DetailUploadBukti.vue')
		},
		{
			path: '/list-upload-bukti/:slug',
			name: 'print-upload-bukti',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/listUploadBukti/PrintUploadBukti.vue')
		},
		{
			path: '/lap-transaksi-enduser/',
			name: 'lap-transaksi-enduser',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/lapTransaksiEnduser/LapTransaksiEnduser.vue')
		},
		{
			path: '/lap-transaksi-enduser/:type/:slug',
			name: 'detail-transaksi-enduser',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/lapTransaksiEnduser/DetailTransaksiEnduser.vue')
		},
		{
			path: '/list-transaksi-enduser/:slug',
			name: 'print-transaksi-enduser',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/lapTransaksiEnduser/PrintTransaksiEnduser.vue')
		},
		{
			path: '/mutasi-saldo-belanja/',
			name: 'mutasi-saldo-belanja',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/transaksiProduk/mutasiSaldoBelanja/MutasiSaldoBelanja.vue')
		},
		{
			path: '/transfer-saldo/',
			name: 'transfer-saldo',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/ewallet/transferEwallet/TransferEwallet.vue')
		},
		{
			path: '/histori-transfer-saldo/',
			name: 'histori-transfer-saldo',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/ewallet/historiTransfer/HistoriTransfer.vue')
		},
		{
			path: '/list-reward/',
			name: 'list-reward',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/reward/ListReward.vue')
		},
		{
			path: '/reward-saya/',
			name: 'reward-saya',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/reward/HistoryReward.vue')
		},
		{
			path: '/buat-pesan/:code?',
			name: 'buat-pesan',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/buatPesan/BuatPesan.vue')
		},
		{
			path: '/inbox/',
			name: 'inbox',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/inbox/Inbox.vue')
		},
		{
			path: '/detail-inbox/:id?',
			name: 'detail-inbox',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/inbox/components/DetailMessage.vue')
		},
		{
			path: '/pesan-terkirim/',
			name: 'pesan-terkirim',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/pesanTerkirim/PesanTerkirim.vue')
		},
		{
			path: '/detail-pesan-terkirim/:id?',
			name: 'detail-pesan-terkirim',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/pesanTerkirim/components/DetailMessage.vue')
		},
		{
			path: '/arsip/',
			name: 'arsip',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/arsip/Arsip.vue')
		},
		{
			path: '/detail-arsip/:id?',
			name: 'detail-arsip',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/pesan/arsip/components/DetailMessage.vue')
		},
		{
			path: '/testimoni/',
			name: 'testimoni',
			beforeEnter: isAuth,
			component: () => import ('@/views/vo/testimoni/Testimoni.vue')
		},]
	},
	{
		path: '*',
		component: () => import ('@/components/layout/vo/ErrorPage.vue'),
		children: [{
			path: '/maintenance',
			component: () => import ('@/views/Maintenance.vue')
		},
		{
			path: '*',
			name: 'not-found',
			component: () => import ('@/views/404.vue')
		}]
	}],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
});
